// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"results-module--wrapper--3HUVB","resultsGraphic":"results-module--resultsGraphic--2dsdL","report":"results-module--report--3Teh0"};